import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { AnswersDto } from "./CvpGetAnswers";
import { QuestionForm } from "./QuestionFormTypes";

export const answerQuestionAnonymous = withNextApi<
  CvpAnswerQuestionAnonymousResponse,
  CvpAnswerQuestionAnonymousParameters
>("/cvp/CvpAnswerQuestionAnonymous", { method: "POST" });

export interface CvpAnswerQuestionAnonymousResponse extends BackendResponse {
  item: number;
}

export interface CvpAnswerQuestionAnonymousParameters extends NextApiParams {
  answer: AnswersDto;
  token: string;
}

export const deleteAnswerAnonymous = withNextApi<
  CvpDeleteAnswerAnonymousResponse,
  CvpDeleteAnswerAnonymousParameters
>("/cvp/CvpAnswerQuestionAnonymous", { method: "DELETE" });

export interface CvpDeleteAnswerAnonymousResponse extends BackendResponse {
  item: number;
}

export interface CvpDeleteAnswerAnonymousParameters extends NextApiParams {
  id: number;
  token: string;
}
